export interface SynopsisSection {
  heading: string;
  body: string[];
}

export interface Episode {
  id: string;
  number: number;
  title: string;
  tagline: string;
  summary: string;
  cover: string;
  still: string;
  date: string;
  director: string;
  writer: string;
  cast: string[];
  tags: string[];
  duration: string;
  rating: number;
  region: string;
  characters: string[];
  synopsis: SynopsisSection[];
}

export const episodes: Episode[] = [
  {
    id: "ep-01",
    number: 1,
    title: "归来的裂痕",
    tagline: "所有人都装作什么都没发生过，可那封未寄出的信，先一步撕开了这一切。",
    summary:
      "阔别三年后，长子凯文带着一桩不愿提起的旧事回到家中，一场本应平静的家庭晚宴，因为一封被意外发现的信而彻底失控。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20with%20a%20lonely%20figure%20standing%20before%20a%20rain%20streaked%20window%2C%20deep%20crimson%20and%20amber%20rim%20lighting%2C%20film%20noir%20mood%2C%20moody%20shadow%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-01&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20scene%20of%20an%20elegant%20dim%20dining%20room%20with%20candlelight%2C%20deep%20crimson%20and%20amber%20tones%2C%20long%20shadows%2C%20film%20noir%20atmosphere%2C%20moody%20cinematic%20lighting%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-01&orientation=landscape",
    date: "2026-03-08",
    director: "马克·霍兰",
    writer: "伊莲娜·科尔",
    cast: ["伊桑·布莱克", "玛戈·雷诺兹", "卢卡斯·凯恩", "索菲亚·维拉"],
    tags: ["家庭伦理", "悬疑", "回归"],
    duration: "52 分钟",
    rating: 9.1,
    region: "美国",
    characters: ["凯文·阿什福德", "玛格丽特·阿什福德", "丹尼尔·阿什福德"],
    synopsis: [
      {
        heading: "三年的沉默",
        body: [
          "剧集以一个缓慢的长镜头开场：凯文·阿什福德站在老宅门前，行李箱的轮子碾过潮湿的石阶。三年前他离开这座小镇时，没有人送他；如今他回来，也没有人问为什么。",
          "阿什福德宅邸依旧光鲜，擦得发亮的银器、母亲玛格丽特亲手布置的餐桌，一切都像在演一出「我们很好」的戏。只有二儿子丹尼尔的眼神，泄露了这个家庭真正的温度。",
        ],
      },
      {
        heading: "被翻出的那封信",
        body: [
          "晚宴进行到一半，一封写给凯文的旧信从书房的抽屉里滑落。信上的字迹属于已经去世的父亲。玛格丽特当场要求把信收好，凯文却当着所有人的面读出了第一行。",
          "空气凝固的那几秒，是本集最重要的转折。丹尼尔放下刀叉，莉娜起身离开餐桌——每个人似乎都早知道信里写了什么，只有观众被留在门外。",
        ],
      },
      {
        heading: "裂痕初现",
        body: [
          "本集并没有揭晓信的全部内容，而是用大量的沉默与视线交换，把悬念压到最后一刻。结尾，凯文独自坐在台阶上，把那封信折好放进内袋，抬头望向二楼亮着灯的窗户。",
          "这部剧真正要讲的，从来不是那封信本身，而是这个家庭用了多少年，才把一件事藏到今天。",
        ],
      },
    ],
  },
  {
    id: "ep-02",
    number: 2,
    title: "晚宴与旧账",
    tagline: "每一句寒暄背后，都藏着一笔从未结清的账。",
    summary:
      "为了维持表面的体面，玛格丽特决定照常举办一年一度的家族晚宴。客人们的到来，让阿什福德家埋藏多年的旧账一件件浮出水面。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20an%20empty%20long%20banquet%20table%20with%20flickering%20candles%2C%20deep%20crimson%20and%20golden%20amber%20lighting%2C%20dramatic%20shadows%2C%20moody%20film%20noir%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-02&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20ballroom%20dinner%20scene%20lit%20by%20chandeliers%2C%20deep%20crimson%20and%20amber%20tones%2C%20rich%20textures%2C%20long%20shadows%2C%20film%20noir%20mood%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-02&orientation=landscape",
    date: "2026-03-15",
    director: "马克·霍兰",
    writer: "伊莲娜·科尔",
    cast: ["玛戈·雷诺兹", "卢卡斯·凯恩", "索菲亚·维拉", "内森·福特"],
    tags: ["家族", "晚宴", "对峙"],
    duration: "48 分钟",
    rating: 8.9,
    region: "美国",
    characters: ["玛格丽特·阿什福德", "丹尼尔·阿什福德", "莉娜·阿什福德"],
    synopsis: [
      {
        heading: "一场必须举办的晚宴",
        body: [
          "玛格丽特坚信，只要晚宴照常举行，家族的体面就还在。她亲自挑选菜单、调整座次，甚至为凯文准备了「合适的」邻座。",
          "但这一集的镜头始终在观察「座次」——谁坐在谁旁边，谁刻意被隔开，谁的位置被空着。一张餐桌，成了整个家族权力关系的缩略图。",
        ],
      },
      {
        heading: "旧账三连",
        body: [
          "先是生意伙伴内森·福特提到一笔被遗忘的投资，接着莉娜被追问当年突然退学的原因，最后连丹尼尔都不得不解释自己为何一直住在老宅。",
          "三段质问层层递进，玛格丽特每一次都能用一句轻描淡写挡回去，观众却越来越清楚：这个家没有秘密，只有默契。",
        ],
      },
      {
        heading: "楼梯上的对话",
        body: [
          "晚宴散场后，凯文拦住了独自上楼的母亲。这是母子二人多年来第一次真正的对话，也只有短短三分钟。",
          "「你以为你回来，是为了揭穿我。」玛格丽特说完这句话，转身关上了门。本集在此结束，留下一个被彻底点燃的问题。",
        ],
      },
    ],
  },
  {
    id: "ep-03",
    number: 3,
    title: "第 14 街的少年",
    tagline: "他以为逃出了那条街，可那条街一直跟着他。",
    summary:
      "倒叙回到十年前，凯文与挚友在破败街区共同经历的夏天被完整呈现，那场改变两人命运的事故，也第一次有了细节。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20a%20rainy%20narrow%20city%20street%20at%20night%2C%20deep%20crimson%20neon%20and%20amber%20reflections%2C%20film%20noir%20mood%2C%20moody%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-03&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20rainy%20city%20street%20at%20night%2C%20deep%20crimson%20neon%20glow%20and%20amber%20streetlights%2C%20wet%20asphalt%20reflections%2C%20film%20noir%20mood%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-03&orientation=landscape",
    date: "2026-03-22",
    director: "伊莲娜·科尔",
    writer: "马克·霍兰",
    cast: ["伊桑·布莱克", "内森·福特", "凯拉·莫里斯"],
    tags: ["倒叙", "青春", "往事"],
    duration: "55 分钟",
    rating: 9.3,
    region: "美国",
    characters: ["凯文·阿什福德", "埃里克·索耶"],
    synopsis: [
      {
        heading: "十年前的那个夏天",
        body: [
          "本集大胆地把主线完全交给回忆。十年前的凯文还不姓「阿什福德」，他住在第 14 街，最好的朋友叫埃里克·索耶。",
          "两个少年一起打工、一起攒钱、一起计划着离开。导演用了大量手持镜头与暖色滤镜，让这段日子成为整部剧里唯一明亮的段落。",
        ],
      },
      {
        heading: "那场事故的真相",
        body: [
          "事故发生在第 14 街尽头的旧仓库。凯文本可以留下，但他选择了离开；埃里克留在原地，承担了全部后果。",
          "这场戏没有配乐，只有雨声和两个人的呼吸。观众终于明白，凯文回到阿什福德家，逃避的从来不是家人，而是自己。",
        ],
      },
      {
        heading: "回到现在",
        body: [
          "结尾，镜头切回现在，凯文在深夜拨通了一个号码，却在接通前挂断。这个未完成的动作，比任何台词都更有重量。",
        ],
      },
    ],
  },
  {
    id: "ep-04",
    number: 4,
    title: "莉娜的真相",
    tagline: "她不是不想说，她只是不知道该从哪一句开始。",
    summary:
      "一直被当作「叛逆小女儿」的莉娜，本集迎来属于自己的视角。她退学的真正原因，以及她与这个家族的微妙关系，被彻底揭开。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20a%20young%20woman%20silhouette%20against%20a%20large%20window%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20shadows%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-04&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20elegant%20study%20room%20with%20a%20glowing%20desk%20lamp%2C%20deep%20crimson%20and%20amber%20tones%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-04&orientation=landscape",
    date: "2026-03-29",
    director: "马克·霍兰",
    writer: "索菲亚·维拉",
    cast: ["索菲亚·维拉", "玛戈·雷诺兹", "卢卡斯·凯恩"],
    tags: ["角色聚焦", "成长", "秘密"],
    duration: "50 分钟",
    rating: 9.0,
    region: "美国",
    characters: ["莉娜·阿什福德", "玛格丽特·阿什福德", "丹尼尔·阿什福德"],
    synopsis: [
      {
        heading: "被误解的叛逆",
        body: [
          "在家人眼里，莉娜是最不懂事的那一个。本集第一次把镜头交给她，观众才看到：每次「不懂事」，都是她替别人挡下的尴尬。",
        ],
      },
      {
        heading: "退学那天",
        body: [
          "时间回到她退学的那一天。她并没有像传闻说的那样与人冲突，而是在一场并不属于她的风波里，选择了沉默。",
          "这场戏的调度极为克制，几乎全靠人物的微表情完成。索菲亚·维拉的表演是整集的核心。",
        ],
      },
      {
        heading: "与母亲的对峙",
        body: [
          "莉娜终于对母亲说出了那句憋了多年的话：「你保护的是这个家，还是你自己？」玛格丽特第一次没有反驳。",
        ],
      },
    ],
  },
  {
    id: "ep-05",
    number: 5,
    title: "沉默的代价",
    tagline: "有些事不说，不是原谅，是把刀留在原地。",
    summary:
      "家族律师带来一份旧遗嘱，让本就紧绷的关系彻底断裂。丹尼尔必须在「母亲」与「哥哥」之间做出选择。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20a%20sealed%20old%20document%20on%20a%20dark%20table%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20shadows%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-05&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20law%20office%20interior%20with%20bookshelves%20and%20amber%20desk%20light%2C%20deep%20crimson%20accents%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-05&orientation=landscape",
    date: "2026-04-05",
    director: "马克·霍兰",
    writer: "伊莲娜·科尔",
    cast: ["卢卡斯·凯恩", "内森·福特", "玛戈·雷诺兹", "伊桑·布莱克"],
    tags: ["遗嘱", "抉择", "对峙"],
    duration: "51 分钟",
    rating: 9.2,
    region: "美国",
    characters: ["丹尼尔·阿什福德", "玛格丽特·阿什福德", "凯文·阿什福德"],
    synopsis: [
      {
        heading: "第三份遗嘱",
        body: [
          "律师带来的不是遗物，而是第三份遗嘱——一份在所有人都以为财产早已分配完毕之后才出现的文件。",
        ],
      },
      {
        heading: "丹尼尔的选择",
        body: [
          "一直站在母亲一边的丹尼尔，第一次动摇了。他必须在母亲的体面与哥哥的归来之间选一个。",
          "本集用一整场十分钟的家庭会议来呈现这次抉择，长镜头让人物的每一次呼吸都无处可藏。",
        ],
      },
      {
        heading: "断裂",
        body: [
          "会议不欢而散。结尾，丹尼尔独自站在空荡的客厅，把那份遗嘱放进火里，又及时抽了出来。这个动作，暗示了后续走向。",
        ],
      },
    ],
  },
  {
    id: "ep-06",
    number: 6,
    title: "灰烬之前",
    tagline: "火可以烧掉纸，但烧不掉写在上面的名字。",
    summary:
      "一场几乎烧毁档案室的火灾，把所有人的注意力引向那批被刻意保存的旧文件，也让一个隐藏最深的人露出破绽。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20smoldering%20embers%20and%20smoke%20in%20a%20dark%20room%2C%20deep%20crimson%20glow%20and%20amber%20sparks%2C%20film%20noir%20mood%2C%20moody%20shadows%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-06&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20archive%20room%20with%20burning%20embers%20and%20smoke%2C%20deep%20crimson%20glow%20and%20amber%20light%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-06&orientation=landscape",
    date: "2026-04-12",
    director: "伊莲娜·科尔",
    writer: "马克·霍兰",
    cast: ["伊桑·布莱克", "凯拉·莫里斯", "内森·福特"],
    tags: ["火灾", "调查", "转折"],
    duration: "49 分钟",
    rating: 8.8,
    region: "美国",
    characters: ["凯文·阿什福德", "埃里克·索耶", "内森·福特"],
    synopsis: [
      {
        heading: "午夜的火光",
        body: [
          "档案室在半夜起火。凯文冲进浓烟里抢出半份文件，也因此第一次与多年前的旧识正面相遇。",
        ],
      },
      {
        heading: "是谁点火",
        body: [
          "警方的结论是意外，但剧中给出了足够多的暗示让观众自行判断。本集刻意不揭晓答案，把主动权交给观众。",
        ],
      },
      {
        heading: "灰烬里的名字",
        body: [
          "结尾，凯文在烧焦的纸页上读到半个名字。镜头停格，本集结束。这是全剧第一次把悬念从「是什么」转向「是谁」。",
        ],
      },
    ],
  },
  {
    id: "ep-07",
    number: 7,
    title: "面具下的脸",
    tagline: "戴着面具太久，连自己都忘了原本的样子。",
    summary:
      "玛格丽特在慈善晚会上发表了一场完美的演讲，而台下的每一个人都知道，这场演讲是为了掩盖刚刚发生的事。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20an%20elegant%20theatrical%20mask%20in%20shadow%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-07&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20elegant%20ballroom%20stage%20with%20a%20podium%20and%20warm%20amber%20spotlight%2C%20deep%20crimson%20drapes%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-07&orientation=landscape",
    date: "2026-04-19",
    director: "马克·霍兰",
    writer: "伊莲娜·科尔",
    cast: ["玛戈·雷诺兹", "索菲亚·维拉", "卢卡斯·凯恩"],
    tags: ["慈善晚会", "伪装", "高光"],
    duration: "47 分钟",
    rating: 9.0,
    region: "美国",
    characters: ["玛格丽特·阿什福德", "莉娜·阿什福德", "丹尼尔·阿什福德"],
    synopsis: [
      {
        heading: "完美的演讲",
        body: [
          "玛格丽特走上台，讲述了一个关于「家」的故事。台下的掌声越热烈，观众越能感到寒意。",
        ],
      },
      {
        heading: "台下的人",
        body: [
          "镜头依次扫过每一位家人的脸：有人在微笑，有人在忍泪，有人干脆闭上了眼睛。",
          "这一集几乎没有对白，却把人物关系讲得比任何一集都清楚。",
        ],
      },
      {
        heading: "卸妆",
        body: [
          "晚会结束，玛格丽特回到化妆间，独自对镜卸下首饰。镜中的她第一次显得疲惫。本集在此收束。",
        ],
      },
    ],
  },
  {
    id: "ep-08",
    number: 8,
    title: "旧梦重演",
    tagline: "历史不会重复，但会押着同样的韵脚。",
    summary:
      "新一代人开始重复上一代人的选择，凯文发现，自己正在变成当年那个他最不想成为的人。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20mirrored%20reflections%20in%20a%20dim%20hallway%20with%20amber%20light%2C%20deep%20crimson%20accents%2C%20film%20noir%20mood%2C%20moody%20shadows%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-08&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20long%20hallway%20with%20mirrors%20and%20amber%20sconces%2C%20deep%20crimson%20accents%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-08&orientation=landscape",
    date: "2026-04-26",
    director: "伊莲娜·科尔",
    writer: "马克·霍兰",
    cast: ["伊桑·布莱克", "内森·福特", "凯拉·莫里斯", "索菲亚·维拉"],
    tags: ["轮回", "命运", "反思"],
    duration: "53 分钟",
    rating: 9.4,
    region: "美国",
    characters: ["凯文·阿什福德", "埃里克·索耶", "莉娜·阿什福德"],
    synopsis: [
      {
        heading: "同样的选择",
        body: [
          "凯文在处理一件事时，做出了和当年父亲一模一样的选择。他自己几乎没有察觉，是莉娜点破了他。",
        ],
      },
      {
        heading: "镜子戏",
        body: [
          "本集的调度核心是一面面镜子。每当人物做出关键决定，镜头里总会多出一个「过去的自己」。",
          "这场戏被誉为整季的表演高峰，导演用空间完成了对「悔恨」的诠释。",
        ],
      },
      {
        heading: "打断轮回",
        body: [
          "结尾，凯文在最后一刻改变了决定。这是全季第一次有人真正打断了轮回，也为后续的转折埋下伏笔。",
        ],
      },
    ],
  },
  {
    id: "ep-09",
    number: 9,
    title: "最后一夜",
    tagline: "当所有灯都亮起，反而再也没有地方可以躲。",
    summary:
      "真相在家族聚餐的最后一夜全面爆发，每个人都被迫直面自己多年来的沉默，承担应得的代价。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20a%20grand%20dark%20house%20at%20night%20with%20all%20windows%20lit%20amber%2C%20deep%20crimson%20sky%2C%20film%20noir%20mood%2C%20moody%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-09&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20living%20room%20at%20night%20with%20many%20candles%20and%20amber%20light%2C%20deep%20crimson%20accents%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-09&orientation=landscape",
    date: "2026-05-03",
    director: "马克·霍兰",
    writer: "伊莲娜·科尔",
    cast: ["伊桑·布莱克", "玛戈·雷诺兹", "卢卡斯·凯恩", "索菲亚·维拉", "内森·福特"],
    tags: ["高潮", "真相", "爆发"],
    duration: "58 分钟",
    rating: 9.6,
    region: "美国",
    characters: ["凯文·阿什福德", "玛格丽特·阿什福德", "丹尼尔·阿什福德", "莉娜·阿什福德"],
    synopsis: [
      {
        heading: "所有灯都亮起",
        body: [
          "这一夜，宅邸里所有的灯都被点亮。导演用前所未有的亮度，呈现一场无所遁形的对峙。",
        ],
      },
      {
        heading: "每个人都要开口",
        body: [
          "凯文、玛格丽特、丹尼尔、莉娜依次发言，多年的沉默被一句句撕开。没有背景音乐，只有对白与呼吸。",
          "这十分钟是本季的叙事核心，也是所有伏笔的回收点。",
        ],
      },
      {
        heading: "代价",
        body: [
          "真相说出口，并不等于解脱。结尾，有人离开，有人留下，有人终于哭了。留下一地无法复原的关系。",
        ],
      },
    ],
  },
  {
    id: "ep-10",
    number: 10,
    title: "重写结局",
    tagline: "结局不是忘记，而是选择带着它继续生活。",
    summary:
      "大结局。所有人都在尝试为这个家庭写下一个新的结局，有人选择原谅，有人选择远行，而真相终于被郑重地安放。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20drama%20poster%20of%20a%20lone%20figure%20walking%20toward%20a%20warm%20amber%20dawn%20horizon%2C%20deep%20crimson%20and%20golden%20tones%2C%20film%20noir%20mood%2C%20hopeful%20yet%20moody%20atmosphere%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=ats2-cover-10&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=cinematic%20dark%20misty%20road%20at%20dawn%20with%20warm%20amber%20light%20breaking%20through%2C%20deep%20crimson%20tones%2C%20moody%20film%20noir%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1600&height=900&seq=ats2-still-10&orientation=landscape",
    date: "2026-05-10",
    director: "马克·霍兰",
    writer: "伊莲娜·科尔",
    cast: ["伊桑·布莱克", "玛戈·雷诺兹", "卢卡斯·凯恩", "索菲亚·维拉", "内森·福特"],
    tags: ["大结局", "和解", "新生"],
    duration: "62 分钟",
    rating: 9.5,
    region: "美国",
    characters: ["凯文·阿什福德", "玛格丽特·阿什福德", "莉娜·阿什福德"],
    synopsis: [
      {
        heading: "一封的回信",
        body: [
          "凯文终于动笔，写下了那封迟到十年的回信。全剧的第一封信与最后一封信在此完成闭环。",
        ],
      },
      {
        heading: "各自的选择",
        body: [
          "没有人得到完美的结局：玛格丽特选择留下，丹尼尔选择离开，莉娜选择重新开始，凯文选择不再逃避。",
        ],
      },
      {
        heading: "重写结局",
        body: [
          "最后一幕，凯文走出宅邸，天光初亮。他没有回头，但脚步很稳。这部剧最终要说的，是「带着它继续生活」。",
        ],
      },
    ],
  },
];

export const episodeById = (id: string): Episode | undefined =>
  episodes.find((episode) => episode.id === id);